var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"divide-y divide-border-cart space-y-6"},[_c('BlockCommentList',{attrs:{"list":_vm.list,"td-comment":_vm.tdComment,"show-load-more":_vm.showMore,"loading":_vm.loading},on:{"loadMore":_vm.loadMore}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }